// import { DataSource } from 'ng2-smart-table/lib/lib/data-source/data-source';
import { Observable } from 'rxjs';

import { ServerDataSource } from 'angular2-smart-table';
import { Book } from './book';
import { Model } from './common/.base.model';
import { EntityConfigTemplate } from './common/entity-config.interface';
import { FormConfigTemplate } from './common/form-config-template.interface'
// import { ViewCell } from 'ng2-smart-table';

export interface Author extends Model {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  books?: Book[];
}

export const AuthorConfig: EntityConfigTemplate = {
  meta: { entityName: "Author", entityPluralName: "Authors", titleField: 'name', view: false, attachedToField: 'books'},
  name: { title: "Name", valuePrep: (_cell_, row) => `${row?.firstName} ${row?.lastName}`, calculatedField: true },
  firstName: { type: "text" },
  lastName: { type: "text" },
  email: { type: "text" },
  phone: { type: "text" },
  books: { type: "relation", isForeignKey: true, valuePrep: (_cell_, row) => `${row?.books?.length | 0}` },
}

export const AuthorFormConfig: FormConfigTemplate = {
  tabs: [
    {
      title: "Author Details",
      columns: [
        {
          size: "col-12",
          type: "form",
          sections: [
            {
              rows: [
                {
                  fields: [
                    { name: "firstName", label: "First Name", type: "text", required: true, size: "col-6" },
                    { name: "lastName", label: "Last Name", type: "text", required: true, size: "col-6" },
                  ]
                },
                {
                  fields: [
                    { name: "email", label: "Email", type: "text", required: false, size: "col-6" },
                    { name: "phone", label: "Phone", type: "text", required: false, size: "col-6" },
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
}

export abstract class AuthorData {
  abstract get gridDataSource(): ServerDataSource;
  abstract list(pageNumber: number, pageSize: number): Observable<Author[]>;
  abstract get(id: string): Observable<Author>;
  abstract update(Author: Author): Observable<Author>;
  abstract create(Author: Author): Observable<Author>;
  abstract delete(id: string): Observable<boolean>;
  
}




